import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import Tooltip from '@material-ui/core/Tooltip';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Box from '@material-ui/core/Box';
import ButtonBase from '@material-ui/core/ButtonBase';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { EXTERNAL_WALL_MATERIAL_CHANGED } from '../../../../redux/actions/actionTypes'



const useStyles = makeStyles(theme => ({
  photo: {
    height: theme.spacing(10)
  },
  button: {
    borderRadius: 5,
    width: "100%",
    height: "100%"
  },
  bold: {
    fontWeight: "bold"
  },
  materialTitle: {
    display: "inline-block",
    marginBottom: "10px",
    fontWeight: "bold",
    color: "black"
  }
}))

/* 
    Component used to select a material
*/
function SelectMaterial(props) {
  const selectUValue = {
    'EW1': '0.32',
    'EW2': '0.3',
    'EW3': '0.26',
    'EW4': '0.95',
    'EW5': '1.4',
    'RF1': '0.3',
    'RF2': '0.22',
    'RF3': '0.3',
    'RF4': '0.32',
    'GF1': '0.22',
    'GF2': '0.22',
    'GF3': '0.31',
    'IPI1': '-',
    'IPI2': '-',
    'IPI3': '-',
    'PW1': '-',
    'PW2': '-',
    'PW3': '-',
    'FC1': '-',
    'FC2': '-',
    'FC3': '-',
    'FC4': '-',
    'WD1': '1.8',
    'WD2': '1.6',
    'WD3': '4.8',
    'WD4': '4.6',

  }
  const selectUValueFt = {
    'EW1': '0.056',
    'EW2': '0.053',
    'EW3': '0.046',
    'EW4': '0.167',
    'EW5': '0.247',
    'RF1': '0.053',
    'RF2': '0.039',
    'RF3': '0.053',
    'RF4': '0.056',
    'GF1': '0.039',
    'GF2': '0.039',
    'GF3': '0.055',
    'IPI1': '-',
    'IPI2': '-',
    'IPI3': '-',
    'PW1': '-',
    'PW2': '-',
    'PW3': '-',
    'FC1': '-',
    'FC2': '-',
    'FC3': '-',
    'FC4': '-',
    'WD1': '0.317',
    'WD2': '0.282',
    'WD3': '0.845',
    'WD4': '0.810',

  }
  const styles = useStyles();
  const dispatch = useDispatch()
  const [workingOnItText, setWorkingOnItText] = useState('')

  const { open, onClose, onSelect, sheetName, elements } = props;

  const [buttonDisabled, setButtonDisabled] = useState(false)

  let material_elements = [], i, j, k, row, row_element;

  const units = useSelector(state => state.globalFormData.buildingInfo.units)
  const currency = useSelector(state => state.globalFormData.costs.currency)


  j = 1;
  for (i = 0; i < Math.ceil((elements.length - 1) / 4); i++) {
    row = [];
    // The row can have 4 elements at max
    k = j + 4;
    while (j < elements.length && j < k) {
      // Retrieve the element and append the photo
      row_element = elements[j];
      row[row.length] = elements[j];

      j++;
    }
    material_elements[material_elements.length] = row;

  }

  function uvalue(param) {
    if (units == 'm') {
      return (<span><b>U-Value: {selectUValue[param]} (w/m²k) </b></span>)
    } else {
      return (<span><b>U-Value: {selectUValueFt[param]} Btu/(h⋅ft²⋅°F) </b></span>)
    }
  }

  function emmission(param) {
    if (units == 'm') {
      return (<span><b>Emmission: {param[2]} kgCO<sub>2e</sub>/ms²</b></span>)
    } else {
      return (<span><b>Emmission: {param[3]} kgCO<sub>2e</sub>/ft²</b></span>)
    }
  }

  /*   
      Material elements has the structure as follows

      B -> Buildup number
      D -> Description
      E -> Carbon emission

      [ [[B,D,E], [B,D,E], [B,D,E], [B,D,E]], [[B,D,E], [B,D,E], [B,D,E]]  ]

      Each element of the first array is a row containing a maximum of 4 elements(arrays)
  */


  return (
    <Dialog onClose={onClose} open={open} fullWidth>
      <DialogTitle>Select a construction</DialogTitle>
      <DialogContent>

        {/* Iterate through each row  */}
        {material_elements.map((row, n1) => (
          <Grid container justifyContent="center" spacing={2} key={n1}>

            {/* Iterate through each row */}
            {row.map((element, n2) => (

              <Grid item xs={12} sm={3} key={n2}>

                {/* <Tooltip title={element[1].description} arrow> */}
                <Tooltip title={
                  <React.Fragment>
                    <p>{element[1].description}</p>
                    <br />
                    {uvalue(element[0])}
                    <br />
                    {emmission(element)}
                  </React.Fragment>

                } arrow>
                  <ButtonBase className={styles.button} onClick={() => {
                    // const selectedMaterialId = element[0]
                    // console.log('element+++++++++++++++++', element)
                    // // debugger;
                    // if (selectedMaterialId.startsWith('EW') || selectedMaterialId.startsWith('RF') || selectedMaterialId.startsWith('WD')) {
                    // dispatch({
                    //   type: EXTERNAL_WALL_MATERIAL_CHANGED,
                    //   payload: {}
                    // })
                    // }

                    onSelect(element[0])
                  }}>

                    <Box display="flex" flexDirection="column" justifyContent="space-between"
                      padding={2} style={{ height: "100%" }}>
                      <div>
                        <Box display="flex" justifyContent="center">
                          <img src={element[1].thumb_url} alt='' className={styles.photo} />
                        </Box>

                        {/* Put a new line after a comma */}
                        <Typography align="center" variant="body2">
                          <span className={styles.materialTitle} key={'material-title'}>
                            {element[1].title}<br />
                          </span>
                        </Typography>
                      </div>
                    </Box>
                  </ButtonBase>

                </Tooltip>

              </Grid>
            ))}

          </Grid>
        ))}

        <button type="button" style={{ padding: '5px', margin: '5px' }} className="btn btn-primary btn-lg"
          disabled={buttonDisabled}
          onClick={(e) => {
            setButtonDisabled(true);
            setWorkingOnItText('We are working on this feature!');
            setTimeout(() => {
              setWorkingOnItText('');
              setButtonDisabled(false);
            }, 2000)
          }}
        >Design your own</button>

        <div style={{ margin: '10px' }}>
          <p style={{ color: 'red' }}>{workingOnItText}</p>
        </div>

      </DialogContent>
    </Dialog>
  )
};

export default SelectMaterial;